//* Libraries imports
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { SnackbarProvider } from "notistack";

//* Components imports
import App from "@/App";
import { Toaster } from "@components/ui/sonner";

//* Store imports
import store from "@app/store";

//* Utils imports
import { queryClient } from "@/utils/query-client";

//* Styles imports
import "@/index.css";

const container = document.getElementById("app");
if (!container) throw new Error("Failed to find the root element");
const root = createRoot(container);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={3500}
      >
        <App />
        <Toaster />
      </SnackbarProvider>
    </QueryClientProvider>
  </Provider>,
  // </React.StrictMode>
);
